module.exports = __webpack_public_path__ + "img/stamp_verify.06987c92.png";